import { render, staticRenderFns } from "./FreezeRecords.vue?vue&type=template&id=83cab63e&scoped=true"
import script from "./FreezeRecords.vue?vue&type=script&lang=js"
export * from "./FreezeRecords.vue?vue&type=script&lang=js"
import style0 from "./FreezeRecords.vue?vue&type=style&index=0&id=83cab63e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cab63e",
  null
  
)

export default component.exports